import React from 'react';
import { useSitesManagement } from './useSitesManagement';
import { AdminDashboardHeader } from '../AdminDashboard/AdminDashboardHeader';
import { StatsCards } from './StatsCards';
import { SitesTable } from './SitesTable';
import { EditSiteModal } from './EditSiteModal';
import { DeleteSiteModal } from './DeleteSiteModal';

export const AdminSitesManagement: React.FC = () => {
  const {
    authLoading,
    isAuthenticated,
    isAdmin,
    logout,
    sites,
    filteredSites,
    isLoading,
    searchTerm,
    setSearchTerm,
    editingSite,
    showEditModal,
    editFormData,
    setEditFormData,
    startEdit,
    cancelEdit,
    handleUpdateSite,
    siteToDelete,
    showDeleteModal,
    startDelete,
    cancelDelete,
    handleDeleteSite,
    handleToggleLandingPage,
    isSubmitting,
  } = useSitesManagement();

  if (authLoading || isLoading) {
    return (
      <div className="page-container flex items-center justify-center">
        <div className="text-center animate-fade-in">
          <div className="w-12 h-12 mx-auto mb-4 spinner"></div>
          <p className="text-gray-600 font-medium">
            {authLoading ? 'Authenticating...' : 'Loading sites...'}
          </p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !isAdmin) {
    return null; // Will redirect
  }

  return (
    <div className="page-container">
      <AdminDashboardHeader onLogout={logout} />

      {/* Main Content */}
      <main className="page-content max-w-7xl mx-auto py-8 sm:px-6 lg:px-8">
        <div className="px-4 sm:px-0">
          <StatsCards sites={sites} />

          <SitesTable
            sites={filteredSites}
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
            onEdit={startEdit}
            onDelete={startDelete}
            isSubmitting={isSubmitting}
          />
        </div>
      </main>

      {/* Edit Site Modal */}
      {showEditModal && editingSite && (
        <EditSiteModal
          site={editingSite}
          formData={editFormData}
          onFormDataChange={setEditFormData}
          onSave={handleUpdateSite}
          onCancel={cancelEdit}
          onToggleLandingPage={handleToggleLandingPage}
          isSubmitting={isSubmitting}
        />
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && siteToDelete && (
        <DeleteSiteModal
          site={siteToDelete}
          onConfirm={handleDeleteSite}
          onCancel={cancelDelete}
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
};

export default AdminSitesManagement;
